import { VSF_LOCALE_COOKIE, VSF_STORE_COOKIE } from '@vue-storefront/core';

const storeCookiesPlugin = ({ $cookies }) => {
  if (!$cookies.get(VSF_STORE_COOKIE) && $cookies.get(VSF_LOCALE_COOKIE)) {
    $cookies.set(VSF_STORE_COOKIE, $cookies.get(VSF_LOCALE_COOKIE));
  }
};

export default storeCookiesPlugin;
